import React from 'react'
import PropTypes from 'prop-types'
import { useRouteMatch } from 'react-router-dom'
import Box from '@material-ui/core/Box'
import DescriptionIcon from 'components/material-symbol/icons/Description'
import AgeGroupChip from 'components/age-group-chip'
import {
  SettingsLinkRow,
  SettingsSection,
} from 'pages/pga-coach/settings/settings-components'
import useSettingsStyles from 'pages/pga-coach/settings/settings.styles'
import { connectHits } from 'react-instantsearch-dom'
import { titleToURL } from '../../lib/transformStage'
import { gtmEvent } from 'lib/gtm'

const cardPath = (hit, path) => {
  const prefix = path.startsWith('/pga-coach')
    ? '/pga-coach/training-resources/activity-plans/'
    : '/activity-plans/'

  return `${prefix}${titleToURL(hit.stage).name}/plans/${hit.objectID}`
}

const Hits = ({
  hits,
  showSection = true,
  sectionEyebrow = 'Featured plans',
  sectionSubtitle = 'Select a plan to view activities and lesson details.',
}) => {
  const settingsStyles = useSettingsStyles()
  const { path } = useRouteMatch()

  const handleClick = name => {
    gtmEvent({
      event: 'activities-click',
      activitiesCategory: 'coach-activities',
      activitiesAction: 'featured-plan-click',
      activitiesLabel: name,
    })
  }

  const rows = hits.map(hit => (
    <SettingsLinkRow
      key={hit.objectID}
      to={cardPath(hit, path)}
      onClick={() => handleClick(hit.title)}
      icon={<DescriptionIcon />}
      iconWrapClassName={settingsStyles.rowIconTinted}
      title={hit.title}
      trailing={
        <Box className={settingsStyles.rowTags}>
          <AgeGroupChip label={`${hit.totalDurationMins} Minutes`} />
        </Box>
      }
      classes={settingsStyles}
    />
  ))

  if (!showSection) {
    return <>{rows}</>
  }

  return (
    <SettingsSection
      eyebrow={sectionEyebrow}
      subtitle={sectionSubtitle}
      classes={settingsStyles}
    >
      {rows}
    </SettingsSection>
  )
}

Hits.propTypes = {
  hits: PropTypes.array.isRequired,
  showSection: PropTypes.bool,
  sectionEyebrow: PropTypes.string,
  sectionSubtitle: PropTypes.string,
}

const ActivityPlanCards = connectHits(Hits)

export default ActivityPlanCards
